// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;I will bless the Lord who has given me counsel,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and in the night watches he instructs my heart.<br> </p> </div></div>";
// Exports
module.exports = code;